"use client";

import { useEffect, useState } from "react";

const ReadingProgress = ({ target = "article" }: { target?: string }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const article = document.querySelector(target);

    if (!article) {
      return;
    }

    let frame = 0;

    const measure = () => {
      frame = 0;
      const { top, height } = article.getBoundingClientRect();
      const distance = height - window.innerHeight;
      const read = distance <= 0 ? (top <= 0 ? 1 : 0) : -top / distance;

      setProgress(Math.min(1, Math.max(0, read)));
    };

    const schedule = () => {
      if (!frame) {
        frame = requestAnimationFrame(measure);
      }
    };

    measure();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);

    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      cancelAnimationFrame(frame);
    };
  }, [target]);

  return (
    <div
      aria-hidden="true"
      className="absolute left-none bottom-none h-[3px] w-full overflow-hidden"
    >
      <div
        className="h-full bg-primary-800 origin-left"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  );
};

export default ReadingProgress;
